export const appendScriptToBody = (script: string) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = script; // nosem

  if (wrapper.getElementsByTagName('script').length > 0) {
    const newScript = document.createElement('script');

    Array.prototype.slice.call(wrapper.getElementsByTagName('script')).forEach((sourceTag) => {
      if (typeof sourceTag !== 'object') {
        return;
      }

      if (sourceTag.hasAttribute('src')) {
        newScript.src = sourceTag.getAttribute('src') || '';
      } else {
        const inlineScript = document.createTextNode(sourceTag.innerHTML);

        newScript.appendChild(inlineScript);
      }

      document.body.appendChild(newScript);
    });
  } else if (wrapper.firstChild) {
    document.body.appendChild(wrapper.firstChild);
  }
};

export const appendScriptToHead = (script: string) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = script; // nosem

  if (wrapper.getElementsByTagName('script').length > 0) {
    const newScript = document.createElement('script');

    const scriptElements: Array<HTMLScriptElement> = Array.prototype.slice.call(wrapper.getElementsByTagName('script'));

    scriptElements.forEach((sourceTag) => {
      if (typeof sourceTag !== 'object') {
        return;
      }

      if (sourceTag.hasAttribute('src')) {
        newScript.src = sourceTag.getAttribute('src') || '';
      } else {
        const inlineScript = document.createTextNode(sourceTag.innerHTML);

        newScript.appendChild(inlineScript);
      }
      document.head.appendChild(newScript);
    });
  } else if (wrapper.firstChild) {
    document.head.appendChild(wrapper.firstChild);
  }
};
